import { create } from 'zustand';

interface AppState {
  spinner: boolean;
  isReady: boolean;
  showSpinner: () => void;
  hideSpinner: () => void;
  setReady: () => void;
}

export const useAppState = create<AppState>((set) => ({
  spinner: true,
  isReady: false,
  showSpinner: () => set({ spinner: true, isReady: false }),
  hideSpinner: () => set({ spinner: false }),
  setReady: () => set({ isReady: true }),
}));
